module.exports = __webpack_public_path__ + "static/img/anxun52.b9c669f1.png";